export default class {
	idDocumento
	tipoRegistroDocumento
	situacaoDocumento

	constructor(id, tipoRegistroDocumento, situacao) {
		this.idDocumento = id
		this.tipoRegistroDocumento = tipoRegistroDocumento
		this.situacaoDocumento = situacao
	}
}
